// extracted by mini-css-extract-plugin
module.exports = {"label":"ShippingOptionLabel_label__RTdxj","title":"ShippingOptionLabel_title__aKtb6","subLabel":"ShippingOptionLabel_subLabel__6FkDa"};